import React from "react";
import { Link } from "react-router-dom";
import lineAnimation from "../../lottie/left_lines.json";
import Lottie from "lottie-react";

export default function AIARSuccessStory() {
  return (
    <section
      id="banner"
      className="relative flex justify-center w-full py-52 pt-24 px-0 sm:px-4 md:px-8 lg:px-16 xl:px-64 overflow-hidden bg-white"
    >
      {/* Lottie animations positioned to match ServiceOne */}
      <div className="absolute flex justify-between w-full h-full top-0 left-0">
        <div className="w-1/2 flex items-center">
          <Lottie animationData={lineAnimation} loop={true} />
        </div>
        <div className="w-1/2 flex items-center justify-end">
          <Lottie
            animationData={lineAnimation}
            className="transform rotate-180"
            loop={true}
          />
        </div>
      </div>
      
      <div className="relative w-full max-w-[1860px] overflow-hidden bg-main-gray md:rounded-[20px] z-10">
        {/* Content with updated styling */}
        <div className="w-full max-w-[1506px] theme-container mx-auto relative z-[2]">
          <div className="grid grid-cols-12 z-10 pt-[70px] lg:pt-[120px] lg:pb-[120px]">
            <div className="col-span-12 sm:col-span-10 sm:col-start-2 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 my-auto px-4 sm:px-0">
              <div className="flex gap-2.5 relative z-10 px-3 sm:px-6 py-1.5 sm:py-3 rounded-[40px] border border-purple/20 bg-purple/5 items-center w-fit">
                <span className="font-semibold text-purple text-14 sm:text-16">
                  SUCCESS STORY - AIAR
                </span>
              </div>
              <h1
                className="text-4xl md:text-65 tracking-tight font-semibold text-main-black mt-7 max-w-[900px] relative z-10"
                data-depth="-0.28"
              >
                Leveraging The Power Of LLMs
              </h1>
              <p className="text-18 font-regular font-inter text-paragraph mt-5 md:mt-5 max-w-[900px] relative z-10">
                LLM platforms like ChatGPT, Gemini and LLAMA have immense capability but knowing its strengths and weaknesses is the secret to a successful deployment.
                AIAR is one of the world's first self-guided, and AI-powered startup accelerator. This meant not just an accelerated timeline but inventing new paradigms. New user experiences, innovative prompt engineering, a flexible RAG architecture, future-proofed loose coupling with the back-end… and much more. This ambition had to be met with deep expertise.
              </p>

              <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[900px]">
                <div className="bg-white border border-[#e3e7fa] rounded-lg p-6 hover:shadow-common group hover:border-purple common-transition">
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-yellow/20 rounded-full mr-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <h3 className="text-main-black text-lg font-semibold">THE PROBLEM</h3>
                  </div>
                  <p className="text-paragraph">
                    How do you build a startup accelerator without people? More importantly how do you build it so it provides high value and high engagement?
                  </p>
                </div>

                <div className="bg-white border border-[#e3e7fa] rounded-lg p-6 hover:shadow-common group hover:border-purple common-transition">
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-yellow/20 rounded-full mr-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <h3 className="text-main-black text-lg font-semibold">THE SOLUTION</h3>
                  </div>
                  <p className="text-paragraph">
                    The Informulate team assessed the needs, then proposed a new user experience, a loosely coupled architecture, a custom knowledge base while taking advantage of powerful ChatGPT capabilities.
                  </p>
                </div>
              </div>

              <div className="mt-8 bg-white border border-[#e3e7fa] rounded-lg p-6 hover:shadow-common group hover:border-purple common-transition">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-yellow/20 rounded-full mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <h3 className="text-main-black text-lg font-semibold">THE RESULT</h3>
                </div>
                <p className="text-paragraph">
                  The AIAR product is the first of it's kind in bringing a self-guided startup accelerator to market. The team is positioned to not just locally but nationally and beyond.
                </p>
              </div>

              <div className="flex flex-col gap-3 mt-8 sm:flex-row sm:gap-6 justify-center">
                <a href="https://aiar.co" target="_blank" rel="noopener noreferrer" className="pb-10 sm:mb-0">
                  <div className="home-two-btn-white group before:bg-purple after:bg-purple border-purple hover:border-purple">
                    <span className="relative z-10 py-1 text-base font-semibold transition-all duration-300 group-hover:text-black text-white font-inter">
                      Visit Aiar.co 
                    </span>
                    <svg
                      className="relative z-10"
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="transition-all duration-300 group-hover:stroke-main-black stroke-white"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- content end  --> */}
    </section>
  );
}
